import { createLucideIcon } from "lucide-react";

export const ArrowExport = createLucideIcon(
    "ArrowExport",
    [
        [
            "path",
            {
                d: "M12 4.66663C12.5163 4.77368 12.9059 4.95235 13.219 5.25055C14 5.9945 14 7.19187 14 9.58661C14 11.9814 14 13.1787 13.219 13.9227C12.4379 14.6666 11.1808 14.6666 8.66667 14.6666H7.33333C4.81918 14.6666 3.5621 14.6666 2.78105 13.9227C2 13.1787 2 11.9814 2 9.58661C2 7.19187 2 5.9945 2.78105 5.25055C3.09412 4.95235 3.48367 4.77368 4 4.66663",
                key: "w70dqm",
            },
        ],
        [
            "path",
            {
                d: "M8.0169 1.3337C7.9084 1.3292 7.7994 1.368 7.7022 1.45C7.0979 1.9601 6 3.286 6 3.286",
                key: "1nf7rm",
            },
        ],
        [
            "path",
            {
                d: "M8.0169 1.3337C8.1141 1.3378 8.2108 1.3766 8.2979 1.4501C8.9021 1.9603 10 3.2859 10 3.2859",
                key: "1hiv8d",
            },
        ],
        [
            "path",
            {
                d: "M8.0169 1.3337L8 9.3334",
                key: "1o34tp",
            },
        ],
    ],
);
